module.exports = __webpack_public_path__ + "img/task.dcd8fc52.svg";